export class Situation {
    id: number;
    name: string;
}


